const getImageUrl = (src: string) => {
  return `url('${process.env.NODE_ENV === 'production' ? '/_next-assets' : '/static'}${src}');`;
};

export default getImageUrl;
